import React from 'react';
import { ClientSideWizardConfiguration } from '../../../../content-composer/src/contexts/ClientSideWizard/types';
import { useWizardGoToPreviousStep } from '../../../../content-composer/src/contexts/ClientSideWizard/hooks';
import { RejectReasonStep } from './steps/RejectReasonStep';
import { PayrollInitiateStep } from './steps/PayrollInitiateStep';
import { PayrollExecuteStep } from './steps/PayrollExecuteStep';

const useApproveRejectPayrollFlowConfig = (
  authAction: string | null,
  onToggleDrawer?: () => void,
): ClientSideWizardConfiguration => {
  const goToPreviousStep = useWizardGoToPreviousStep();
  if (authAction === 'approve') {
    return {
      currentStep: 'payrollInitiate',
      data: {
        payrollInitiate: {
          stepId: 'payrollInitiate',
          isFirstStep: false,
          hasStepIndicator: false,
          cancelHidden: false,
          Component: () => (
            <PayrollInitiateStep authAction={authAction} onToggleDrawer={onToggleDrawer} resetFlow={goToPreviousStep} />
          ),
          parameters: {},
        },
        payrollExecute: {
          stepId: 'payrollExecute',
          isFirstStep: false,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: () => <PayrollExecuteStep authAction={authAction} />,
          parameters: {},
        },
      },
    };
  } else {
    return {
      currentStep: 'rejectReasonStep',
      data: {
        rejectReasonStep: {
          stepId: 'rejectReasonStep',
          isFirstStep: true,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: RejectReasonStep,
          parameters: {},
        },
        payrollInitiate: {
          stepId: 'payrollInitiate',
          isFirstStep: false,
          hasStepIndicator: false,
          cancelHidden: false,
          Component: () => <PayrollInitiateStep authAction={authAction} hasRejectionReason={true} />,
          parameters: {},
        },
        payrollExecute: {
          stepId: 'payrollExecute',
          isFirstStep: false,
          cancelHidden: false,
          hasStepIndicator: false,
          Component: () => <PayrollExecuteStep authAction={authAction} />,
          parameters: {},
        },
      },
    };
  }
};

export { useApproveRejectPayrollFlowConfig };
